function initDelayedTemplates() {
  const templates = document.querySelectorAll('template.delay-load');

  templates.forEach((tpl) => {
    const parentClass = tpl.dataset.parent;

    // Country selector modal should be outside the navigation
    if (tpl.content.querySelector('#country_selection')) {
      document.body.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
      return;
    }

    // All other delayed templates retain their existing behaviour
    const templateParent = parentClass
      ? document.querySelector(`.${CSS.escape(parentClass)}`)
      : null;

    if (templateParent) {
      templateParent.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
    } else {
      console.warn('Delayed template parent not found:', parentClass);
    }
  });

  if (typeof initScrollers === 'function') { initScrollers(); }
  if (typeof detectScrollContainerOverflow === 'function') { detectScrollContainerOverflow(); }
  if (typeof initiSlideShow === 'function') { initiSlideShow(); }
  if (typeof initFeaturedCollection === 'function') { initFeaturedCollection(); }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDelayedTemplates);
} else {
  initDelayedTemplates();
}

window.addEventListener('resize', () => {
  detectScrollContainerOverflow();

  document.querySelectorAll('.scroller-wrapper').forEach(sw => {
    setupScrollDots(sw);
    updateScrollButtons(sw);
    updateActiveDot(sw);
  });
});

document.addEventListener('shopify:section:load', () => {
  initScrollers();
  detectScrollContainerOverflow();

  document.querySelectorAll('.scroller-wrapper').forEach(sw => {
    setupScrollDots(sw);
  });
});


/**
 * lazy-loading behaviour for sections.
 */
const lazySections = document.querySelectorAll('.lazy-section');
const rrObserver = new IntersectionObserver((entries, obs) => {
  
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const target = entry.target;
    const tpl = target.querySelector('template.lazy-load');

    if (tpl) {
      target.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
      
      if (typeof initMiniCompare === 'function') { initMiniCompare(); }
      if (typeof initReviews === 'function') { initReviews(); }
    }
    setTimeout(() => {
      target.classList.add('section-visible');
    }, 500);

    obs.unobserve(target);
  });

}, {
  root: null,
  rootMargin: '100px',
  threshold: 0.1
});

lazySections.forEach(section => rrObserver.observe(section));

/** Card-aligned targets, with the final target clamped to show the last card. */
function getCardScrollTargets(sw) {
  const container = sw.querySelector('.scroll-container');
  const cards = sw.querySelectorAll('.product-ul > li');
  const max = Math.max(0, container.scrollWidth - container.clientWidth);
  const targets = [0];
  const origin = cards.length ? cards[0].getBoundingClientRect().left : 0;

  cards.forEach(card => {
    const target = Math.min(max, Math.max(0, card.getBoundingClientRect().left - origin));
    if (target - targets[targets.length - 1] > 1) targets.push(target);
  });
  if (max - targets[targets.length - 1] > 1) targets.push(max);
  return targets;
}

/**
 * Updates the left and right scroll button active states
 * based on the current scroll position of the container.
 */
function updateScrollButtons(sw) {
  const leftBtn = sw.querySelector('.scroll-button.left');
  const rightBtn = sw.querySelector('.scroll-button.right');
  const scrollContainer = sw.querySelector('.scroll-container');

  if (!scrollContainer || !leftBtn || !rightBtn) return;

  const scrollLeft = scrollContainer.scrollLeft;
  const clientWidth = scrollContainer.clientWidth;
  const scrollWidth = scrollContainer.scrollWidth;

  const atStart = scrollLeft <= 1;
  const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

  if (sw.hasAttribute('data-scroll-by-card')) {
    leftBtn.disabled = atStart;
    rightBtn.disabled = atEnd;
  }

  leftBtn.classList.toggle('active', !atStart);
  rightBtn.classList.toggle('active', !atEnd);
}

/**
 * Checks each scroller wrapper for horizontal overflow,
 * toggles overflow classes, clears dots when not needed,
 * and refreshes buttons and dots when scrolling is available.
 */
function detectScrollContainerOverflow() {
  document.querySelectorAll('.scroller-wrapper').forEach(sw => {
    const leftBtn = sw.querySelector('.scroll-button.left');
    const rightBtn = sw.querySelector('.scroll-button.right');
    const scrollContainer = sw.querySelector('.scroll-container');
    const dotsContainer = sw.querySelector('.scroll-dots');

    if (!scrollContainer || !leftBtn || !rightBtn) return;

    const hasOverflow = scrollContainer.scrollWidth > scrollContainer.clientWidth;

    sw.classList.toggle('has-overflow', hasOverflow);
    sw.classList.toggle('no-overflow', !hasOverflow);

    if (!hasOverflow) {
      leftBtn.classList.remove('active');
      rightBtn.classList.remove('active');

      if (dotsContainer) {
        dotsContainer.innerHTML = '';
      }
    } else {
      updateScrollButtons(sw);
      setupScrollDots(sw);
    }
  });
}

/**
 * Finds all scroller wrappers and initializes them once by:
 * - attaching click handlers to scroll buttons
 * - attaching scroll listeners to the container
 * - setting up dots and initial button/dot states
 */
function initScrollers() {
  const scrollers = document.querySelectorAll('.scroller-wrapper');

  scrollers.forEach(sw => {
    if (sw.classList.contains('scroller-initialized')) return;

    const btns = sw.querySelectorAll('.scroll-button');
    const scrollContainer = sw.querySelector('.scroll-container');

    if (!scrollContainer || !btns.length) return;

    sw.classList.add('scroller-initialized');

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (sw.hasAttribute('data-scroll-by-card')) {
          if (btn.disabled) return;
          const targets = getCardScrollTargets(sw);
          const current = scrollContainer.scrollLeft;
          const target = btn.classList.contains('right')
            ? targets.find(value => value > current + 1)
            : targets.slice().reverse().find(value => value < current - 1);
          if (target !== undefined) {
            scrollContainer.scrollTo({ left: target, behavior: 'smooth' });
          }
          return;
        }
        const visibleWidth = scrollContainer.clientWidth;
        const scrollAmount = visibleWidth - 80;
        const direction = btn.classList.contains('right') ? scrollAmount : -scrollAmount;

        scrollContainer.scrollBy({
          left: direction,
          behavior: 'smooth'
        });
      });
    });

    scrollContainer.addEventListener('scroll', () => {
      updateScrollButtons(sw);
      updateActiveDot(sw);
    });

    setupScrollDots(sw);
    updateScrollButtons(sw);
    updateActiveDot(sw);
  });
}

/**
 * Builds the correct number of pagination dots for a scroller
 * based on the visible width and total scrollable width,
 * and attaches click handlers to jump between scroll positions.
 */
function setupScrollDots(sw) {
  const scrollContainer = sw.querySelector('.scroll-container');
  const dotsContainer = sw.querySelector('.scroll-dots');

  if (!scrollContainer || !dotsContainer) return;

  dotsContainer.innerHTML = '';

  const visibleWidth = scrollContainer.clientWidth;
  const totalWidth = scrollContainer.scrollWidth;
  const step = visibleWidth - 80;

  if (step <= 0 || totalWidth <= visibleWidth) return;

  const targets = sw.hasAttribute('data-scroll-by-card') ? getCardScrollTargets(sw) : null;
  const pageCount = targets ? targets.length : Math.ceil((totalWidth - visibleWidth) / step) + 1;

  for (let i = 0; i < pageCount; i++) {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.classList.add('scroll-dot');
    dot.setAttribute('aria-label', `Go to slide ${i + 1}`);

    dot.addEventListener('click', () => {
      scrollContainer.scrollTo({
        left: targets ? targets[i] : i * step,
        behavior: 'smooth'
      });
    });

    dotsContainer.appendChild(dot);
  }

  updateActiveDot(sw);
}

/**
 * Updates the active pagination dot by calculating
 * which scroll "page" is currently closest to the
 * container's current scroll position.
 */
function updateActiveDot(sw) {
  const scrollContainer = sw.querySelector('.scroll-container');
  const dots = sw.querySelectorAll('.scroll-dot');

  if (!scrollContainer || !dots.length) return;

  const visibleWidth = scrollContainer.clientWidth;
  const step = visibleWidth - 80;
  const scrollLeft = scrollContainer.scrollLeft;

  const targets = sw.hasAttribute('data-scroll-by-card') ? getCardScrollTargets(sw) : null;
  const index = targets
    ? targets.reduce((closest, target, i) =>
        Math.abs(target - scrollLeft) < Math.abs(targets[closest] - scrollLeft) ? i : closest, 0)
    : Math.round(scrollLeft / step);

  dots.forEach((dot, i) => {
    dot.classList.toggle('active', i === index);
  });
}

/*
  Adds countdown timer functionality to any element with the class 'rr-countdown-timer'
  Follow structure of UK-Theme/snippets/pdp-promo-banner-v3.liquid
*/
const timerContainers = document.querySelectorAll('.rr-countdown-timer');

if (timerContainers) {
  timerContainers.forEach(timer => {
    const daysEl = timer.querySelector('[data-countdown-days]');
    const hoursEl = timer.querySelector('[data-countdown-hours]');
    const minutesEl = timer.querySelector('[data-countdown-minutes]');
    const secondsEl = timer.querySelector('[data-countdown-seconds]');

    let totalSeconds =
      Number(timer.dataset.days) * 86400 +
      Number(timer.dataset.hours) * 3600 +
      Number(timer.dataset.minutes) * 60 +
      Number(timer.dataset.seconds);

    function updateCountdown() {
      if (totalSeconds <= 0) {
        totalSeconds = 0;
      }

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      daysEl.textContent = days;
      hoursEl.textContent = hours;
      minutesEl.textContent = minutes;
      secondsEl.textContent = seconds;

      if (totalSeconds > 0) {
        totalSeconds--;
      }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
}
 
// Cloudflare Input data recording
const API_BASE = 'https://input-search-worker.matt-robinson-0dd.workers.dev';

let lastSearch = null;

async function recordSearch(searchBtn) {
  const inputSelector = document.querySelector(
    `.${searchBtn.dataset.searchInput}`
  );

  if (!inputSelector) return;

  const payload = {
    url: window.location.href,
    inputName: inputSelector.name || 'unknown_input',
    inputValue: inputSelector.value || 'empty',
    resultsCount: window.rrSparesVisibleCount || 0
  };

  // Stop duplicate searches
  if (
    lastSearch &&
    JSON.stringify(payload) === JSON.stringify(lastSearch)
  ) {
    return;
  }

  // Store a copy of the payload
  lastSearch = { ...payload };

  try {
    const response = await fetch(API_BASE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    console.log('Search recorded:', data);
  } catch (error) {
    console.error('Failed to record search:', error);
  }
}

// Listen for clicks on the search submit buttons
document.addEventListener('click', (e) => {
	const searchBtn = e.target.closest('[data-submit-search="submit-record"]');
	const guaranteeTab = e.target.closest('.guarantee-tab');
  const payLaterTab = e.target.closest('.pay-later-tab');
  const modalLink = e.target.closest('.mr-custom-modalLink');
  const collectionCompareSection = document.querySelector(`.${e.target.getAttribute('data-compare-section')}`);

	if (searchBtn) { recordSearch(searchBtn); }
	if (guaranteeTab) { updateGuaranteeTab(guaranteeTab); }
	if (payLaterTab) { updatePayLaterTab(payLaterTab); }
  if (modalLink) { openModalById(modalLink, e); }
  if (collectionCompareSection) { openCompareOnCollection(collectionCompareSection); }
});

//listens for enter key presses on search inputs
document.addEventListener('keydown', function (event) {
  if (event.key === 'Enter' && document.activeElement.classList.contains('record-input')) {

    const input = document.activeElement;
    if (input.classList.contains('record-input')) {
      const correspondingSearchButton = document.querySelector(`.${input.dataset.searchCorrespondingButton}`);

      event.preventDefault();
      correspondingSearchButton.click();
    }
  }
});

// Utility Bar Dropdown Menu
document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-utility-more-toggle]');
  const openMenus = document.querySelectorAll('.utility-bar-more.is-open');

  if (toggle) {
    const wrapper = toggle.closest('.utility-bar-more');
    const isOpen = wrapper.classList.contains('is-open');

    // Close any other open dropdowns
    openMenus.forEach((menu) => {
      if (menu !== wrapper) {
        menu.classList.remove('is-open');

        const otherToggle = menu.querySelector(
          '[data-utility-more-toggle]'
        );

        if (otherToggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    wrapper.classList.toggle('is-open', !isOpen);

    toggle.setAttribute(
      'aria-expanded',
      String(!isOpen)
    );

    return;
  }

  // Don't close when clicking inside dropdown
  if (event.target.closest('[data-utility-more-dropdown]')) {
    return;
  }

  // Click outside closes dropdown
  openMenus.forEach((menu) => {
    menu.classList.remove('is-open');

    const menuToggle = menu.querySelector(
      '[data-utility-more-toggle]'
    );

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
    }
  });
});


document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document
    .querySelectorAll('.utility-bar-more.is-open')
    .forEach((menu) => {

      menu.classList.remove('is-open');

      const toggle = menu.querySelector(
        '[data-utility-more-toggle]'
      );

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
});

/**
 * MR Header Search Takeover
 */
function initMrHeaderSearch() {
  const BREAKPOINT = window.matchMedia('(max-width: 1300px)');

  const search = document.querySelector('[data-mr-header-search]');
  const toggle = document.querySelector('[data-mr-header-search-toggle]');
  const close = document.querySelector('[data-mr-header-search-close]');

  if (!search || !toggle) return;

  // Prevent duplicate event listeners
  if (search.dataset.mrSearchInitialized === 'true') return;
  search.dataset.mrSearchInitialized = 'true';


  const getSearchInput = () => {
    return (
      search.querySelector('[data-live-search-input]') ||
      search.querySelector('input[type="search"]') ||
      search.querySelector('input[name="q"]') ||
      search.querySelector('input[type="text"]')
    );
  };


  const openSearch = () => {
    if (!BREAKPOINT.matches) return;

    search.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');

    document.body.classList.add('mr-header-search-open');

    requestAnimationFrame(() => {
      const input = getSearchInput();

      if (input) {
        input.focus();
      }
    });
  };


  const closeSearch = () => {
    search.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');

    document.body.classList.remove('mr-header-search-open');

    toggle.focus();
  };


  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    openSearch();
  });


  if (close) {
    close.addEventListener('click', (event) => {
      event.preventDefault();

      closeSearch();
    });
  }


  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      search.classList.contains('is-open')
    ) {
      closeSearch();
    }
  });


  BREAKPOINT.addEventListener('change', (event) => {
    if (!event.matches) {
      search.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');

      document.body.classList.remove('mr-header-search-open');
    }
  });
}


/*
 * Initialise on normal page load
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMrHeaderSearch);
} else {
  initMrHeaderSearch();
}


/*
 * Reinitialise if Shopify reloads the header
 * inside the Theme Editor
 */
document.addEventListener('shopify:section:load', initMrHeaderSearch);

/**
 * Position Clerk live search directly beneath desktop header
 */
function positionClerkLiveSearch() {
  const clerkSearch = document.querySelector(
    '.clerk-instant-search-container.clerk-live-search-container'
  );

  if (!clerkSearch) return;

  // Mobile: results fill width below the search form
  if (window.innerWidth <= 768) {
    const searchForm = document.querySelector(
      '.live-search--takeover .live-search-form'
    );

    if (!searchForm) return;

    const top = Math.ceil(searchForm.getBoundingClientRect().bottom);

    const styles = {
      position: 'fixed',
      inset: 'auto',
      top: `${top}px`,
      right: '0px',
      bottom: '0px',
      left: '0px',
      width: '100vw',
      minWidth: '100vw',
      maxWidth: '100vw',
      height: `calc(100dvh - ${top}px)`,
      minHeight: '0px',
      maxHeight: 'none',
      margin: '0',
      padding: '0',
      boxSizing: 'border-box',
      overflowX: 'hidden',
      overflowY: 'auto'
    };

    Object.entries(styles).forEach(([property, value]) => {
      const cssProperty = property.replace(
        /[A-Z]/g,
        match => '-' + match.toLowerCase()
      );

      if (
        clerkSearch.style.getPropertyValue(cssProperty) !== value ||
        clerkSearch.style.getPropertyPriority(cssProperty) !== 'important'
      ) {
        clerkSearch.style.setProperty(cssProperty, value, 'important');
      }
    });

    return;
  }

  // Desktop: retain existing positioning above 1300px
  if (window.innerWidth <= 1300) return;

  const header = document.querySelector('.site-header-main');
  if (!header) return;

  const headerRect = header.getBoundingClientRect();

  clerkSearch.style.setProperty('position', 'fixed', 'important');
  clerkSearch.style.setProperty('top', `${headerRect.bottom}px`, 'important');
}


const clerkSearchObserver = new MutationObserver(() => {
  positionClerkLiveSearch();
});

clerkSearchObserver.observe(document.body, {
  childList: true,
  subtree: true
});


window.addEventListener('resize', positionClerkLiveSearch);
window.addEventListener('scroll', positionClerkLiveSearch);

/**
 * Make third-party search results scrollable
 */
function makeSearchResultsScrollable() {

  const selectors = [
    '.clerk-live-search-container',
    '.clerk-instant-search-container',

    '.search-flydown',
    '.search-flydown--results',

    '[class*="predictive-search"]',
    '[class*="instant-search"]',
    '[class*="search-results"]',
    '[class*="search-suggestions"]',

    '[data-search-results]',
    '[data-predictive-search]'
  ];

  const elements = document.querySelectorAll(selectors.join(','));

  elements.forEach((element) => {

    const rect = element.getBoundingClientRect();

    /*
     * Ignore elements that aren't currently visible.
     */
    if (
      rect.width === 0 ||
      rect.height === 0
    ) {
      return;
    }

    /*
     * Calculate available viewport height from
     * wherever the app positioned its results.
     */
    const viewportHeight =
      window.visualViewport?.height ||
      window.innerHeight;

    const availableHeight =
      Math.max(
        200,
        viewportHeight - rect.top
      );

    element.classList.add(
      'mr-search-results-scrollable'
    );

    element.style.setProperty(
      '--mr-search-results-height',
      `${availableHeight}px`
    );
  });
}

const searchResultsObserver = new MutationObserver(() => {
  makeSearchResultsScrollable();
});

searchResultsObserver.observe(document.body, {
  childList: true,
  subtree: true
});

window.addEventListener(
  'resize',
  makeSearchResultsScrollable
);

window.addEventListener(
  'scroll',
  makeSearchResultsScrollable,
  { passive: true }
);

if (window.visualViewport) {
  window.visualViewport.addEventListener(
    'resize',
    makeSearchResultsScrollable
  );
}